import StickyComponent from './sticky.component.js';
import StickyContainerDirective from './sticky-container.directive.js';
import StickyManagerDirective from './sticky-manager.directive.js';
export default function Sticky(module) {
    StickyManagerDirective(module);
    StickyContainerDirective(module);
    StickyComponent(module);
};